import { createFileRoute, notFound } from '@tanstack/react-router'

import { CATALOGUE, isCatalogueKind } from '@/features/catalogue/kinds'

export const Route = createFileRoute('/catalogue/$kind')({
  beforeLoad: ({ params }) => {
    if (!isCatalogueKind(params.kind)) throw notFound()
  },
  component: CatalogueKindPage,
})

function CatalogueKindPage() {
  const { kind } = Route.useParams()
  if (!isCatalogueKind(kind)) return null
  const { title, description, Body } = CATALOGUE[kind]
  return (
    <div className="px-4 pt-5 pb-8 lg:px-6">
      <div className="mb-4 flex flex-wrap items-baseline gap-x-3">
        <h1 className="text-[26px]">{title}</h1>
        <p className="text-sm text-neutral-600">{description}</p>
      </div>
      <Body />
    </div>
  )
}
